/**
 * @module cercaliagl/service/ReverseGeocoding
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Service from './Service';
/**
 * @classdesc
 * <b>Javascript ES5</b>
 * ```js
 * const reverseGeocoding = new cercaliagl.service.ReverseGeocoding({ ... });
 * ```
 * Reverse geocoding service obtains an address given a position.
 *
 * Example usage:
 * ```js
 * const reverseGeocoding = new cercaliagl.service.ReverseGeocoding();
 * const position = new cercaliagl.LonLat(-3.696100270, 40.424812754);
 * reverseGeocoding.getDirection(position, (data) => {
 *   console.log(data.cercalia.proximity.gelist.ge);
 * });
 * ```
 *
 * @extends {Service}
 * @api
 */
var ReverseGeocoding = /** @class */ (function (_super) {
    __extends(ReverseGeocoding, _super);
    function ReverseGeocoding() {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {ProximityResult}
         */
        _this.response_ = null;
        return _this;
    }
    /**
     * Gets the address from a coordinate cercalia.LonLat
     * @param {import('../LonLat').default} lonLat Position
     * @param {Function} callbackFn First and unique argument received is {@link import("../servers.js").ProximityResult ProximityResult}
     * @api
     */
    ReverseGeocoding.prototype.getDirection = function (lonLat, callbackFn) {
        var _this = this;
        var mo = "".concat(lonLat.getLat(), ",").concat(lonLat.getLon());
        var params = { cmd: 'reversegeocoding', mo: mo };
        this.getRequest({
            data: params,
            callbackFn: function (data) {
                _this.response_ = data;
                if (callbackFn) {
                    callbackFn(data);
                }
                else {
                    console.warn('No callback function defined'); // eslint-disable-line no-console
                }
            },
        });
    };
    return ReverseGeocoding;
}(Service));
export default ReverseGeocoding;
//# sourceMappingURL=ReverseGeocoding.js.map